import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
import snakeToCamel from "../../../utils/SnakeToCamel";
const actions = {
  getAllBillRequests(context, query) {
    const url = new URL(
      `${endpoints.LARAVEL_BASE_URL}${endpoints.API.billRequests}`
    );
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            const meta = {
              total: res.data.total,
              perPage: res.data.per_page,
              currentPage: res.data.current_page,
              last: res.data.last_page,
              from: res.data.from,
              to: res.data.to
            };
            context.commit("setAllBillRequestsList", {
              data: snakeToCamel(res.data.data),
              meta: meta
            });
            resolve(res);
          }
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  },
  generateBill(context, serviceRequestId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.billRequests}/${serviceRequestId}/prepare-sale-data`
        )
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            resolve(snakeToCamel(res.data));
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default actions;
